import Grid from '@material-ui/core/Grid';
import React, { Component } from 'react';
import styled from 'styled-components';

import { Button, Stack } from '@solvhealth/jigsaw-v1';
// @ts-ignore FIXME: Try `npm install @types/rc-form` if it exists or a... Remove this comment to see the full error message
import { createForm, formShape } from 'rc-form';
import isEmpty from 'lodash/isEmpty';
import { BUTTON_STATUS_LOADING } from '~/components/SolvPatternLibrary/Button/TransitionButton';
import HomeAddress from '../../SolvPatternLibrary/Form/HomeAddress';
import { SINGLE_COLUMN_FORM_WIDTH } from '~/constants/layout';

const FormContainer = styled(Grid).withConfig({ componentId: 'sc-197ant9-0' })`
  max-width: ${SINGLE_COLUMN_FORM_WIDTH}px;
`;

type Props = {
  form: formShape;
  userProfile?: any;
  handleFormSubmit?: (...args: any[]) => any;
  handleCancel?: (...args: any[]) => any;
};

type State = any;

class EditHomeAddressForm extends Component<Props, State> {
  state = {
    submitting: false,
    errors: {},
    buttonStatus: 'initial',
    submitButtonDisabled: true,
  };

  onBlur = (fieldName: any) => {
    const { form } = this.props;
    form.validateFields([fieldName], {}, this.setErrorState(fieldName));
  };

  onSubmit = (e: any) => {
    e.preventDefault();
    this.props.form.validateFields(this.onValidationDone);
  };

  onValidationDone = (fieldErrors: any, values: any) => {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
    this.setErrorState()(fieldErrors);
    if (this.props.userProfile && isEmpty(fieldErrors)) {
      // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      this.props.handleFormSubmit(values);
    }
  };

  onFieldChange = (value: any, fieldName: any) => {
    const { form } = this.props;
    const { errors } = this.state;
    this.setState({ errors: { ...errors, [fieldName]: false } });
    form.setFieldsValue({ [fieldName]: value });

    form.validateFields(this.enableFormSubmissionIfNoErrors);
  };

  setErrorState = (fieldName: any) => (errors: any) => {
    this.enableFormSubmissionIfNoErrors(errors);
    if (isEmpty(errors)) {
      this.setState({ errors: { [fieldName]: false } });
    } else if (fieldName) {
      this.setState({ errors: { [fieldName]: errors[fieldName] } });
    } else {
      this.setState({ errors });
    }
  };

  enableFormSubmissionIfNoErrors = (errors: any) =>
    isEmpty(errors)
      ? this.state.submitButtonDisabled && this.setState({ submitButtonDisabled: false })
      : this.state.submitButtonDisabled || this.setState({ submitButtonDisabled: true });

  render = () => {
    const { errors } = this.state;
    const { userProfile, form } = this.props;

    return (
      <Grid item xs={12}>
        <form data-testid="form" onSubmit={this.onSubmit}>
          <FormContainer container justify="space-between">
            <HomeAddress
              errors={errors}
              form={form}
              onBlur={this.onBlur}
              onFieldChange={this.onFieldChange}
              userProfile={userProfile}
            />
            <Stack pt={4} row space={2}>
              <Button
                data-testid="editaddress-submit"
                disabled={this.state.submitting}
                loading={this.state.buttonStatus === BUTTON_STATUS_LOADING}
                size="small"
                type="submit"
              >
                Save
              </Button>
              {this.props.handleCancel && (
                <Button onClick={this.props.handleCancel} size="small" variant="text">
                  Cancel
                </Button>
              )}
            </Stack>
          </FormContainer>
        </form>
      </Grid>
    );
  };
}

export default createForm()(EditHomeAddressForm);
